import styled from 'styled-components';
import {theme} from '../../../styles/darkTheme';

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const InputField = styled.input<{ type: string; placeholder: string; }>`
  width: 70vw;
  font-size: 18px;
  padding: 15px;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
  background: ${theme.white};
  border: 1px solid ${ theme.inputBorder};
  box-sizing: border-box;
  border-radius: 8px;
  outline: none;
`;
